import React from "react";
import { isBrowser } from "tools/device";
import { useGetState, useSetState } from "../components/ReduxProvider";

type Props = {};

const ReduxAfterInitializer: React.FC<Props> = () => {
  const storageDeviceId = useGetState("deviceId");
  const setDeviceId = useSetState("deviceId");
  const storageDeviceOs = useGetState("deviceOs");
  const setDeviceOs = useSetState("deviceOs");

  // set deviceId on initialization and store it into redux/localstorage
  React.useEffect(() => {
    const device = (window as any).device;

    let deviceId: string | undefined;
    if (device) {
      deviceId = `${device.model}-${device.uuid}`;
    } else if (!isBrowser()) {
      deviceId = `random_${Math.random().toString(36).substring(2, 9)}`;
    }

    if (device?.platform && device.platform !== storageDeviceOs) setDeviceOs(device.platform.toLowerCase());
    if (deviceId && deviceId !== storageDeviceId) setDeviceId(deviceId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default ReduxAfterInitializer;
